import { useStorage } from '@vueuse/core';
import { defineStore } from 'pinia';

// A fiskaly system is a fiscal register: its identity must survive Chrome
// updates, which rotate the FingerprintJS visitorId. The backend-resolved
// system uuid is kept per location, so a browser serving multiple locations
// holds one identity per location and visiting another location never
// overwrites the first one's.
//
// This is register/location identity, NOT session state: it must survive
// logout and user switches, so it deliberately lives outside the user store
// and must never be reset with the session.
export const useFiskalySystemStore = defineStore('fiskalySystem', () => {
  // Single fixed key + one ref: useStorage registers a window `storage`
  // listener per call, so it must not be created per dynamic location key —
  // getSystemUuid runs on every GraphQL request (apollo/links.ts).
  const systemUuids = useStorage<Record<string, string>>(
    'fiskaly_system_uuids',
    {},
  );

  const getSystemUuid = (locationPublicId: string): string | null =>
    systemUuids.value[locationPublicId] ?? null;

  const storeSystemUuid = (locationPublicId: string, uuid: string): void => {
    systemUuids.value[locationPublicId] = uuid;
  };

  const clearSystemUuid = (locationPublicId: string): void => {
    delete systemUuids.value[locationPublicId];
  };

  return { systemUuids, getSystemUuid, storeSystemUuid, clearSystemUuid };
});
